import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Badge from '../../components/ui/Badge.jsx';
import Button from '../../components/ui/Button.jsx';
import { useApi } from '../../hooks/useApi.js';
import { RouteContext } from '../../router.jsx';

export default function StudentRequestDetail({ params }) {
  const { navigate } = React.useContext(RouteContext);
  const requestId = params?.id;
  const { data, loading, error } = useApi(`/api/requests/${requestId}`, [requestId]);

  if (!requestId) {
    return (
      <div className="page">
        <div className="alert error">Missing request id.</div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Request Details</h1>
          <p className="subtle">Review your course change request status.</p>
        </div>
        <Button variant="secondary" type="button" onClick={() => navigate('/student/requests')}>Back to Requests</Button>
      </div>

      {error ? <div className="alert error">{error}</div> : null}

      {loading || !data ? (
        <p className="subtle">Loading...</p>
      ) : (
        <div className="grid two">
          <Card title="Request Summary">
            <div className="summary-list">
              <div className="summary-row">
                <span>Request ID</span>
                <span>REQ-{data.id}</span>
              </div>
              <div className="summary-row">
                <span>Submitted</span>
                <span>{data.submit_date || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Category</span>
                <span>{data.category || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Change</span>
                <span>{data.remove_course || '—'} → {data.add_course || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Status</span>
                <span>{renderStatus(data)}</span>
              </div>
            </div>
          </Card>

          <Card title="Advisor & Chair Notes">
            <div className="summary-list">
              <div className="summary-row">
                <span>Advisor</span>
                <span>{data.advisor || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Advisor Notes</span>
                <span>{data.advisor_notes || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Chair Notes</span>
                <span>{data.chair_notes || '—'}</span>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

function renderStatus(req) {
  if (req.status === 1 && req.advisor_decision === 0 && req.chair_decision === 0) {
    return <Badge tone="warning">Pending</Badge>;
  }
  if (req.status === 1 && req.advisor_decision === 1 && req.chair_decision === 0) {
    return <Badge tone="info">Chair Review</Badge>;
  }
  if (req.status === 0 && req.chair_decision === 1) {
    return <Badge tone="success">Approved</Badge>;
  }
  if (req.status === 0 && req.advisor_decision === 0) {
    return <Badge tone="error">Declined</Badge>;
  }
  return <Badge tone="info">Closed</Badge>;
}
